// extracted by mini-css-extract-plugin
module.exports = {"root":"Feature1_root__EEEsN","title":"Feature1_title__1rUUW"};